const LESS_THAN_SAMPLE_SIZE_PATTERN = /^(\(\d+\) )?Less Than \d+ Sample Size$/;

/** Matches the Min count group label, "Less Than {min} Sample Size", count-qualified or not. */
export function isLessThanSampleSizeLabel(label: Maybe<string>): boolean {
  return !!label && LESS_THAN_SAMPLE_SIZE_PATTERN.test(label);
}
